import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DateTimeInput.html?raw';

import TimeInput from '../TimeInput/TimeInput';
import '../TimeInput/TimeInput';
import DateInput from '../DateInput/DateInput';
import '../DateInput/DateInput';

import SelectBox from '../SelectBox/SelectBox';
import '../SelectBox/SelectBox';

import docu from './DateTimeInputDocumentation.html?raw';
import { AccessibilityLabelsHelper, DateHelpers } from "../../../more/Helpers";



interface _dateTimeResultValue {
    date: Date, // local Date -- convertiert tu UTC mit Date.prototype.methods .toJSON() && .toISOString() --> wird automatisch ISO/UTC beim JSONStringify !! ()
    timezone: string // Intl.DateTimeFormat().resolvedOptions().timeZone - wenn ohne TimeZoneSelector || TimeZoneSelector._value.timezone
    offsetMinutes: number
}

type zeroToNine = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
type tenToTwentyfour = 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23 |24;
type HH = `0${zeroToNine}` | `${tenToTwentyfour}`;
type mm = '00' | '10' | '20' | '30' | '40' | '50';
type TimeString = `${HH}:${mm}`;

interface TimeslotItem {
    label?: string;
    value: TimeString;
}
class DateTimeInput extends compose(_LabelInputBase) {
    templateString: any = template;

    inputNode: HTMLInputElement;
    labelNode: HTMLLabelElement;
    errorMsgNode: HTMLSpanElement;
    validationMsgNodeContainer = "errorMsgNode";

    date_input: MdsLax<InstanceType<typeof DateInput>>;
    protected time_input: MdsLax<InstanceType<typeof TimeInput>>;
    protected timeslotSelect: MdsLax<InstanceType<typeof SelectBox>>;
    private _useTime: boolean = true;
    private timeSlotMode: boolean = false;
    private _timeSlots: TimeslotItem[];
    private replacementTime: Date = null;

    setDefaultMinTimeIfNull: boolean = false;

    _date_UTC: Date;

    //_date_local: Date;
    private utcOffsetMinutes: number; // in minutes

    private dateTimeInputContainer: HTMLElement;

    focus() {
        this.date_input.focus();
    }

    _value: _dateTimeResultValue = {
        date: null, // local Date!!  convertiert zu UTC mit Date.prototype.methods .toJSON() && .toISOString() --> wird automatisch ISO/UTC beim JSONStringify !! 
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, //LOCALE Timezone, für UTC Values und andere TimeZonen aktiviere den TimezonSelector
        offsetMinutes: 0
    };

    public useTimeslots(value: boolean) {
        this.timeSlotMode = value;

        if (this.timeSlotMode) {
            this.UiModder.domClass.remove(this.timeslotSelect.domNode, "w3-hide");
            this.UiModder.domClass.add(this.time_input.domNode, "w3-hide");

            // styling der selectbox
            this.UiModder.domClass.remove(this.timeslotSelect.domNode, "selectbox");
            this.UiModder.domClass.remove(this.timeslotSelect.getInputNode(), "border");
            this.UiModder.domStyle.set(this.timeslotSelect.getInputNode(), "borderBottom", "none");       
        } else {
            this.UiModder.domClass.add(this.timeslotSelect.domNode, "w3-hide");
            this.UiModder.domClass.remove(this.time_input.domNode, "w3-hide");
        }
    }

    public addTimeslot(value: TimeslotItem | TimeString): void {
        if (typeof (this._timeSlots) == "undefined") {
            this._timeSlots = [];
        }

        if (value instanceof Object) {
            this._timeSlots.push(value);
        } else {
            this._timeSlots.push({
                value: value,
                label: value
            });
        }

        this._drawTimeslots();
    }

    private _drawTimeslots(): void {
        this.timeslotSelect.clear(true);
        for (let i = 0; i < this._timeSlots.length; i++) {
            let item = this._timeSlots[i];

            this.timeslotSelect.addEntry(item.value, item.label, true);
        }

        this.timeslotSelect.constructOptions();
    }

    private _setUseTimeAttr(useTime: boolean) {
        this.useTimeInput(useTime);
    }
    useTimeInput(useTime: boolean, replacementTime: Date = null): void {
        //console.debug("useTimeInput?", useTime, replacementTime);

        this._useTime = useTime;
        //this.time_input.setMandatory(false); //  useTime ? this.isMandatory : false);

        let hours = 0;
        let minutes = 0;
        let seconds = 0;

        if (replacementTime != null) {

            if (typeof (replacementTime) == "string" && typeof (replacementTime["getHours"]) != "function") {
                replacementTime = new Date(replacementTime);
            }

            hours = replacementTime.getHours();
            minutes = replacementTime.getMinutes();
            seconds = replacementTime.getSeconds();
        }

        this.replacementTime = new Date();
        this.replacementTime.setHours(hours);
        this.replacementTime.setMinutes(minutes);
        this.replacementTime.setSeconds(seconds);
        this.replacementTime.setMilliseconds(0);

        this.UiModder.domClass.toggle(this.time_input.domNode, "w3-hide", useTime != true);

        this.setValue();
    }

    protected setPlaceholderValue(): void {
        this.inputNode.placeholder = this.placeholder;
    }

    setReadonly(bReadOnly: boolean): void {
        super.setReadonly.apply(this, arguments as any);

        this.time_input.setReadonly(this.isReadonly);
        this.date_input.setReadonly(this.isReadonly);
    }

    _setReadonlyStyle(): void {

        if (this.labelNode) {
            this.UiModder.domClass.toggle(this.labelNode, "w3-disabled", this.isReadonly);
        }
        
    }


    customValidation(): boolean {
        let date = this._value.date;
        let result: boolean = true;

        if (this.isMandatory == true) {

            if (!this.date_input.getValue() || (this._useTime && !this.time_input.getValue())) {
                result = false;
            }
            if (typeof date == "undefined" || date instanceof Date === false || date == null) {

                //this.validationErrorMsgText = window.translations['PersonData__ValidationError_Mandatory']; // ?!?! persondata??
                result = false;
            }
        }

        // wenn nicht Pflichtfeld: zumindest müssen beide Teile ausgefüllt sein, damit es gültig ist
        else {
            if (this.date_input.getValue() && (this._useTime && !this.time_input.getValue()) ){
                result = false;
            } else if (!this.date_input.getValue() && (this._useTime && this.time_input.getValue())) {
                result = false;
            }
        }

        if (result) {
            if (this.minDateTimeValue) {
                if (date.valueOf() < this.minDateTimeValue) result = false;
                
            }

            if (this.maxDateTimeValue) {
                if (date.valueOf() > this.maxDateTimeValue) result = false;
            }
        }

        return result;
    }

   


    private _onValueChangeTime(): void {
        //console.debug(this.id + " _onValueChangeTime - focused?", this.isFocused);
        this.setValue();
    }

    private _onValueChangeDate(): void {
        //console.debug(this.id + " _onValueChangeDate - focused?", this.isFocused);
        this.setValue();
    }

    /**
     * Ruft den derzeitigen Wert ab, egalisiert aber die im Date-Objekt hinterlegte Zeitzone.
     * Selber Effekt lässt sich manuell mit DateHelpers.dateToLocalISOString erreichen.
     */
    getValueAsLocalISOstring(): string {
        let result = this.getValue();
        if (result && result.date) {
            return DateHelpers.dateToLocalISOString(result?.date);
        }
        return null;
    }

    getValue(): _dateTimeResultValue {
        let result = super.getValue.apply(this, arguments as any) as _dateTimeResultValue;


        if (result && result.date && result.date.valueOf) {
            result = lang.clone(result);
        }

        return result;
    }

    //getLocalDate(): Date {
    //    return this._date_local;
    //}

    getUTCDate(): Date {
        return this._date_UTC; // Achtung!! Gibt immer das UTC Date, kaluliert mit dem lokalen TimezoneOffset!
    }

    setUtcOffsetMinutes(value: number): void {
        this.utcOffsetMinutes = value;
    }

    getUtcOffsetMinutes():number {
        return this.utcOffsetMinutes;
    }

    setMaxTime(maxTime: string): void {
        this.time_input.setMaxTime(maxTime);
    }

    setMinTime(minTime: string): void {
        this.time_input.setMinTime(minTime);
    }

    setMandatory(bMandatory: boolean = true):void {

        this.isMandatory = bMandatory;
        this.setValidationEnabled(bMandatory);
        this.validateInput();
        //this.date_input.setMandatory(bMandatory);
        //this.time_input.setMandatory(bMandatory);

    }

    timeInput_DateToString(dateWithTime: Date): string {
        let hours:string = ("0" + dateWithTime.getHours()).slice(-2); // HH
        let min : string = ("0" + dateWithTime.getMinutes()).slice(-2);  // mm
        //HH:mm
        let timeString = `${hours}:${min}`
        return timeString;
    }

    private setInputValues(newValue?: Date): void {

        this.date_input.setValue(newValue, true);
        this.time_input.setValue(newValue, true);
    }
   

    setValue(newValue?: Date | string, bSuppressChange: boolean = false): void {


        this._value.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone; // Locale IANA TimeZone_Id (Name)
        //console.debug(this.id + " setvalue", newValue);
        let oldValue = this.getValue();
        let strValueOld = oldValue ? JSON.stringify(oldValue) : null;

        if (newValue) {
            //console.debug("datetimeInput - new value is set", newValue);
            if (Object.prototype.toString.call(newValue) === "[object Date]") {
                if (!isNaN((<Date>newValue).getFullYear())) {
                    this._value.date = <Date>newValue;
                    this.setInputValues(<Date>newValue);
                }
            } else if (!isNaN(new Date(<string>newValue).getFullYear())) {
                this._value.date = new Date(<string>newValue);
                this.setInputValues(new Date(<string>newValue));
            }

            if (!this._date_UTC && this._value) {
                this._date_UTC = this.convertDateToUTC(this._value.date);
            }

        } else if (newValue === null) {
            this.date_input.setValue(null, true);
            this.time_input.setValue(null, true);
            this._value.date = null;
        }
        else if (typeof newValue == "undefined") {

            if (this.date_input.getValue()) {


                let dateInputValue: Date = this.date_input.getValue();
                let timeString: string;
                let dateString: string;
                let stringValue: string;

                //console.debug("datetimeInput - date is set");

                if (Object.prototype.toString.call(dateInputValue) === "[object Date]") {
                    if (!isNaN(dateInputValue.getFullYear())) {
                        dateString = this.date_input.toStringISO(this.date_input.getValue()).slice(0, 10);
                    }
                }


                if (this._useTime === true) {
                    if (this.time_input.getValue()) {
                        timeString = this.timeInput_DateToString(this.time_input.getValue());
                    } else if (this.setDefaultMinTimeIfNull === true) {
                        timeString = this.time_input.getMinTime();
                    }
                } else {
                    timeString = this.timeInput_DateToString(this.replacementTime);
                }

                if (timeString) {

                    stringValue = `${dateString}, ${timeString}`;
                    let dateTimeObject = new Date(stringValue); // locale DateTime

                    if (Object.prototype.toString.call(dateTimeObject) === "[object Date]" && isNaN((<Date>dateTimeObject).getFullYear())) {
                        stringValue = `${dateString}T${timeString}:00`;
                        dateTimeObject = new Date(stringValue); // locale DateTime
                    } else if (Object.prototype.toString.call(dateTimeObject) === "[object Date]" && !isNaN((<Date>dateTimeObject).getFullYear())) {
                        // ales ist in ordnung
                    } else {
                        console.error("unexpected date input string format")
                    }


                    this._value.date = dateTimeObject;
                    this.utcOffsetMinutes = dateTimeObject.getTimezoneOffset();
                    this._value.offsetMinutes = this.utcOffsetMinutes;
                    this._date_UTC = this.convertDateToUTC(dateTimeObject);

                    this.setInputValues(dateTimeObject);

                } else {
                    this._value.date = null;
                    this._date_UTC = null;
                }


            } else {
                this._value.date = null;
                this._date_UTC = null;
                //this.time_input.setValue(null, true);
                //console.debug("datetimeInput - no date set");
            }

            // unbedingt eine eigene Kopie des Dates machen, sonst kann das beim Herumreichen zwischen Widgets lustig werden
            if (this._value?.date?.valueOf) {
                this._value.date = new Date(this._value.date.valueOf());
            }
        }

        this.validateInput();

        //console.debug(this.id + " setvalue done", this.getValue());

        if (bSuppressChange === false) {
            let value = this.getValue();
            let strValueNew = value ? JSON.stringify(value) : null;
            
            if (strValueNew != strValueOld) {
                this.__delayValueChangeEmit();

                //// wenn gerade im Fokus: längeres Timeout, damit der User ggf. noch Eingaben fertigmachen kann!
                //if (this.isFocused) {
                //    setTimeout(lang.hitch(this, "emit", "valueChange"), 2000);
                //    setTimeout(lang.hitch(this, "emit", "change"), 2000);
                //} else {
                //    this.emit('valueChange');
                //    this.emit('change');
                //}
                
            }
        }
    }

    // DATE

    /*
     dateObject.getTimezoneOffset() // Returns the time difference between UTC time and local time, in minutes
     dateObject.toUTCString() // Converts a Date object to a string, according to UTC
     dateObject.toISOString() //Returns the date as a string, using the ISO standard
     
     */

    private convertDateToUTC(date: Date): Date {

        let now_utc: number = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
            date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), 0);

        return new Date(now_utc + this.utcOffsetMinutes * 60);

    }

    toStringISO(date: Date): string {
        if (date) {
            let day = ("0" + date.getDate()).slice(-2); //DD
            let month = ("0" + (date.getMonth() + 1)).slice(-2); //MM
            let year = date.getFullYear() //YYYY
            let hours = ("0" + date.getHours()).slice(-2); // HH
            let min = ("0" + date.getMinutes()).slice(-2);  // mm
            let sec = ("0" + date.getSeconds()).slice(-2); // ss

            // YYYY-MM-DDTHH:mm:ss
            let ISOString = `${year}-${month}-${day}T${hours}:${min}:${sec}`;
            return ISOString;
        }

        return null;
    }

    ISOStringToInputValues(iso: string): object {

        if (iso) {
            let dateString = iso.slice(0, 10);
            let timeString = iso.slice(-8);

            return { date: dateString, time: timeString };
        }
        return { date: null, time: null };
    }

    // takes an ISO Date Sttring as a param, turns it in separate date and time values, and sends them to setValue() respectively

    setValueFromString(iso: string): void {
        this.setValue(new Date(iso));
    }

    // Labels

    setDateLabel(newValue: string): void {
        this.date_input.setLabel(newValue);
    }

    setTimeLabel(newValue: string): void {
        this.time_input.setLabel(newValue);
    }

    getDateLabel(): string {
        return this.date_input.getLabel();
    }

    getTimeLabel(): string {
        return this.time_input.getLabel();
    }


    // docu
    getDocumentationContent(): string {
        return docu;
    }

    // dojo
    private _setMinAttr(value: string) {
        if (!value) {
            this.minDateTimeValue = null;
            this.date_input.setMinValue(null);
        }
        else {
            let valueDate = new Date(value);
            if (valueDate && valueDate.getFullYear) {
                let dateValueWotime = new Date(value);
                dateValueWotime.setHours(0, 0, 0);
                this.date_input.setMinValue(dateValueWotime);

                valueDate.setSeconds(0);
                if (!this._useTime) {
                    valueDate.setHours(0, 0, 0);
                    if (this.replacementTime) {
                        valueDate.setHours(this.replacementTime.getHours(), this.replacementTime.getMinutes(), this.replacementTime.getSeconds());
                    }
                }
                this.minDateTimeValue = valueDate.valueOf();
            }
        }

        this.validateInput();
    } private _setMaxAttr(value: string) {
        if (!value) {
            this.maxDateTimeValue = null;
            this.date_input.setMaxValue(null);
        }
        else {
            let valueDate = new Date(value);
            if (valueDate && valueDate.getFullYear) {
                let dateValueWotime = new Date(value);
                dateValueWotime.setHours(23, 59, 59);
                this.date_input.setMaxValue(dateValueWotime);

                valueDate.setSeconds(59);
                if (!this._useTime) {
                    valueDate.setHours(23, 59, 59);
                    if (this.replacementTime) {
                        valueDate.setHours(this.replacementTime.getHours(), this.replacementTime.getMinutes(), this.replacementTime.getSeconds());
                    }
                }
                this.maxDateTimeValue = valueDate.valueOf();
            }
        }

        this.validateInput();
    }
    private maxDateTimeValue: number;
    private minDateTimeValue: number;
    _setMinTimeAttr(minTime: string): void {
        this.setMinTime(minTime);
    }

    _setMaxTimeAttr(maxTime: string): void {
        this.setMinTime(maxTime);
    }



    _setDateLabelAttr(newValue: string): void {
        this.setDateLabel(newValue);
    }

    _getDateLabelAttr(): string {
        return this.getDateLabel();
    }

    _getTimeLabelAttr(): string {
        return this.getTimeLabel();
    }

    _setTimeLabelAttr(newValue: string): void {
        this.setDateLabel(newValue);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.utcOffsetMinutes = new Date().getTimezoneOffset();

        this.validateInput();

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.dateTimeInputContainer, "dateTimeInput", this.labelNode);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DateTimeInput);